import useServiceFactory from "../serviceFactory";
const apiUrl =  `/administracion/liquidacionReporte`;
const useApiRenovacionDocumentos = () => {
    const service = useServiceFactory({ uri: process.env.REACT_APP_API_URL });
    return {
        obtener: async (params) => service.get(`${apiUrl}/obtenerRenovacionDocumentos`, { params, showLoading: true }),
        excel: async (params) => service.get(`${apiUrl}/renovacionDocumentosExcel`,
        {
            params,
            showLoading: true,
            download: true,
            fileName: `DescuentosRenovacionDocumentos.xlsx`
        }),
        }
};

export default useApiRenovacionDocumentos;